import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { subscriptionSlice } from '../../../../../reducers'

const useAccountInfo = () => {
  const accountInfo = useSelector(subscriptionSlice.selectors.selectAccountInfo)
  const accountInfoLoaded = useSelector(
    subscriptionSlice.selectors.selectAccountInfoLoaded
  )

  const isMonthlyPlan = useCallback(() => {
    if (!accountInfoLoaded) {
      return false
    }
    const { plan: { intervalUnit, intervalLength } = {} } = accountInfo
    return intervalUnit === 'months' && intervalLength === 1
  }, [accountInfo, accountInfoLoaded])

  const canSuspend = useCallback(() => {
    if (!accountInfoLoaded) {
      return false
    }
    const { pendingSuspend, suspended, trial } = accountInfo
    return !pendingSuspend && !suspended && !trial
  }, [accountInfo, accountInfoLoaded])

  return {
    accountInfoLoaded,
    accountInfo,
    isMonthlyPlan,
    canSuspend
  }
}

export default useAccountInfo
